import React, { useState } from "react";
import { signIn } from "aws-amplify/auth";
import { SignInSchema } from "../../utils/validation";
import toast from "react-hot-toast";
import ForgotPassword from "./forgotPassword";
import Button from "../common/Button";
import CompleteRegistration from "./CompleteRegistration";
import RegisterNewUser from "./RegisterNewUser";
import GenericForm from "../common/form/GenericForm";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { library } from "@fortawesome/fontawesome-svg-core";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";

library.add(faEye, faEyeSlash);

const SignInPage = ({ getAuthenticatedUser }) => {
  const [isLoading, setLoading] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showCompleteRegistration, setShowCompleteRegistration] =
    useState(false);
  const [userObj, setUserObj] = useState(null);
  const [registerNew, setRegisterNew] = useState(false);

  const [isPasswordVisible, setPasswordVisible] = useState(false)

  if (showForgotPassword) {
    return <ForgotPassword getAuthenticatedUser={getAuthenticatedUser} />;
  }

  if (registerNew) {
    return <RegisterNewUser />;
  }

  if (showCompleteRegistration) {
    return (
      <CompleteRegistration
        user={userObj}
        getAuthenticatedUser={getAuthenticatedUser}
      />
    );
  }

  return (
    <div className="flex flex-1 flex-col justify-center px-6 py-12 lg:px-8 min-h-screen dark:bg-gray-900 dark:text-white">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img
          src="/PC_Horz_Color.svg"
          alt="logo"
          className="mx-auto -mb-10 "
          style={{ width: "600px", height: "auto" }}
        />
        <h2 className="-mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:text-white">
          Sign in to your account
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <GenericForm
          initialValues={{ email: "", password: "" }}
          validationSchema={SignInSchema}
          onSubmit={async (values) => {
            setLoading(true);
            try {
              const user = await signIn({
                username: values.email,
                password: values.password,
              });
              if (
                !user.isSignedIn &&
                user.nextStep.signInStep ===
                  "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED"
              ) {
                setShowCompleteRegistration(true);
                setUserObj(user);
              } else {
                await getAuthenticatedUser(() =>
                  toast.success("You have successfully logged in.")
                );
              }
            } catch (e) {
              toast.error(e.message);
            } finally {
              setLoading(false);
            }
          }}
          fields={[
            {
              key: "email",
              label: "Email address",
              otherProps: {
                type: "email",
              },
            },
            {
              key: "password",
              label: "Password",
              type: isPasswordVisible ? "text" : "password",
              otherProps: {
                customLabel: (
                  <div className="flex items-center justify-between">
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Password
                    </label>
                    <div className="text-sm">
                      <span
                        className="font-semibold text-primary-light hover:text-primary-light cursor-pointer"
                        onClick={() => setShowForgotPassword(true)}
                      >
                        Forgot password?
                      </span>
                    </div>
                  </div>
                ),
              },
              suffix: (
                <button
                  type="button"
                  title={isPasswordVisible ? 'Hide Password' : 'Show Password'}
                  className="h-full -mr-2 px-2 "
                  onClick={() => setPasswordVisible(!isPasswordVisible)}
                >
                  <FontAwesomeIcon
                    icon={isPasswordVisible ? 'eye-slash': 'eye'}
                    size="lg"
                  />
                </button>
              ),
            },
          ]}
          className="block space-y-6"
        >
          <Button type="submit" disabled={isLoading} loading={isLoading}>
            Sign in
          </Button>
        </GenericForm>

        <p className="mt-10 text-center text-sm text-gray-500">
          Not a member?{" "}
          <button
            onClick={() => setRegisterNew(true)}
            className="font-semibold leading-6 text-primary-light hover:text-primary-light"
          >
            Register now!
          </button>
        </p>
      </div>
    </div>
  );
};

export default SignInPage;
